module.exports = __webpack_public_path__ + "img/accuffr_icas.965be722.png";